<template>
  <!-- eslint-disable vue/valid-v-slot -->

  <v-data-table :headers="headers" :items="values" :items-per-page="10" class="elevation-1"  show-expand  :single-expand="true"   item-key="name" :expanded.sync="expanded">

    <template v-slot:expanded-item="{ headers,item }">
      <td :colspan="headers.length">
        <v-list subheader two-line>
          <v-subheader v-if="lsExpandFormSaveds.length > 0" inset>Doldurulan Formlar</v-subheader>

          <p style="margin: 5px;" v-if="lsExpandFormSaveds.length == 0">Forma ait bir başvurunuz bulunmamaktadır.Sağ
            tarafta yer alan 

            
            <v-icon large class="mx-2" >
              mdi-database-arrow-left-outline
            </v-icon>
             butonu ile başvuru yapabilirsiniz</p>

          <v-list-item v-for="itemFormSaved in lsExpandFormSaveds" :key="itemFormSaved.formSavedId">
            <v-list-item-avatar>
              <v-icon class="grey lighten-1" dark>
                mdi-receipt-text-edit-outline
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ itemFormSaved.createDate }} zamanına ait bir başvuru kaydınız bulunmaktadır.</v-list-item-title>

              <v-list-item-subtitle v-if="item.onaylama">{{ itemFormSaved.onayName }}</v-list-item-subtitle>
           
                 <v-list-item-subtitle   style="color: red;" v-if="itemFormSaved.onayDurumId == 4">Reddedilme Nedeni: {{ itemFormSaved.reddedilmeNedeni }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn v-if="![3,4].includes(itemFormSaved.onayDurumId)  && item.onaylama"   color="primary" @click="btnFormSavedDuzenle(itemFormSaved.formSavedId)">
                <v-icon >mdi-table-edit</v-icon>Düzenle
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider inset></v-divider>
        </v-list>


      </td>
    </template>



    <!-- <template v-slot:top>
      <v-toolbar dark color="primary" flat>
        <v-toolbar-title>Formlar</v-toolbar-title>
        <v-dialog v-model="dialog" max-width="1200px">

          <v-card>
            <v-toolbar dark color="primary" flat>
              <v-toolbar-title> <span class="text-h5">{{ formTitle }}</span></v-toolbar-title>
              <template v-slot:extension>

                <v-tabs v-model="tab" fixed-tabs>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#one" class="primary--text">
                    <v-icon>mdi-phone</v-icon>
                  </v-tab>

                  <v-tab href="#two" class="primary--text">
                    <v-icon>mdi-heart</v-icon>
                  </v-tab>

                  <v-tab href="#three" class="primary--text">
                    <v-icon>mdi-account-box</v-icon>
                  </v-tab>
                </v-tabs>
              </template>
            </v-toolbar>
            <v-tabs-items v-model="tab">
              <v-tab-item value="one">
                <v-card flat>
                  <v-card-text>
                    <v-form ref="frmForm">
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="editedItem.name" label="Form Adı" :rules="[required]"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <VDate label="Başlama Tarihi" v-model="editedItem.baslamaTarihi" :rules="[required]">
                            </VDate>

                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <VDate label="Bitiş Tarihi" :rules="[required]" v-model="editedItem.bitisTarihi">
                            </VDate>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-checkbox v-model="editedItem.loginGiris"
                              label="Sisteme giriş yapacak olanlar Giriş Ekranından girsin"></v-checkbox>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-checkbox v-model="editedItem.onaylama"
                              label="Formu onaylama sistemine tabii tut"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">

                            <v-select v-model="editedItem.durumId" :items="durums" item-text="name" :rules="[required]"
                              item-value="id" label="Durum"></v-select>
                          </v-col>

                        </v-row>
                      </v-container>
                    </v-form>

                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="two">
                <v-card flat>
                  <v-card-text>


                    <Filtreleme v-model="filterUser"></Filtreleme>

                 
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="three">
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="10">
                   
                        <v-dialog v-model="dgKullaniciKimlerDegerlendirecek" width="1200">


                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Yetki Seçimi
                            </v-card-title>

                            <v-card-text>

                              <Filtreleme v-if="selectedPersonelItem" v-model="selectedPersonelItem.filter">
                              </Filtreleme>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" text @click="btnKimlerDegerlendirecekAdd">
                                Ekle
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-autocomplete v-model="selectedPersonel" filled :items="personels" return-object
                          item-text="name" label="Personel Listesi" @change="cbPersonelChange"></v-autocomplete>

                      </v-col>
                      <v-col cols="2">
                        <v-btn color="warning" @click="btnSelectedPersonelAdd">
                          Ekle
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>





                        <ul>
                          <li v-for="item in selectedKullanicis" :key="item.id">

                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>{{ item.name }}</v-list-item-title>

                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn color="warning" @click="btnKimlerDegerlendirecekDgShow(item)">
                                  Yetki
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>


                     
                            <v-divider></v-divider>
                            <v-row>


                              <v-col cols="3" sm="3" md="3">
                                Öğrenci Birimleri
                                <ul style="max-height: 250px;overflow-y: auto;">
                                  <li v-for="ogrenciProgram in item.filter.ogrenciProgramIds" :key="ogrenciProgram">{{
                                    ogrenciProgram.name }}</li>
                                </ul>



                              </v-col>
                              <v-divider vertical></v-divider>
                              <v-col cols="3" sm="3" md="3">
                                Akademi Birimleri
                                <ul style="max-height: 250px;overflow-y: auto;">
                                  <li v-for="itemAkademi in item.filter.pbsAkademisyenBirimIds" :key="itemAkademi.id">{{
                                    itemAkademi.name }}</li>
                                </ul>
                              </v-col>
                              <v-divider vertical></v-divider>
                              <v-col cols="3" sm="3" md="3">
                                İdari Birimler
                                <ul style="max-height: 250px;overflow-y: auto;">
                                  <li v-for="itemIdari in item.filter.pbsIdariBirimIds" :key="itemIdari">{{
                                    itemIdari.name }}</li>
                                </ul>
                              </v-col>
                              <v-divider vertical></v-divider>
                              <v-col cols="3" sm="3" md="3">
                                Diğer Birimler
                                <ul style="max-height: 250px;overflow-y: auto;">
                                  <li v-for="itemDiger in item.filter.pbsDigerBirimIds" :key="itemDiger">{{
                                    itemDiger.name }}</li>
                                </ul>
                              </v-col>


                            </v-row>


                          </li>
                        </ul>
                      </v-col>
                    </v-row>


                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <v-card-title>

            </v-card-title>

            <v-card-text>

              <v-dialog scrollable v-model="dgBirim" width="700">


                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Birim Ağaçı
                  </v-card-title>

                  <v-card-text>
                    <v-treeview return-object v-model="selectedBirimIds" selectable :items="items"></v-treeview>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="btnBirimAdd()">
                      Düzenle
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>





            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
     
              <v-btn large color="primary" @click="btnFormSave">
                <v-icon dark>
                  mdi-content-save
                </v-icon>
                Kaydet
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>
    </template> -->



    <template v-slot:item.actions="{ item }">



      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon large @click="editItem(item)" class="mx-2" v-bind="attrs" v-on="on">
            mdi-database-arrow-left-outline
          </v-icon>
        </template>
        <span>Form Veri Girişi</span>
      </v-tooltip>






    


    </template>

  </v-data-table>
</template>
<script>
//import router from '@/router';
import Vue from 'vue';

import router from '@/router/index';
import FormService from '@/services/FormService';

import DurumService from '@/services/DurumService';


import FormSavedService from '@/services/FormSavedService';

export default {
  components: {
 
  },
  name: "KullaniciFormListesi",
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Yeni Form Tanımlama' : 'Form Güncelle'
    },
  },
  data() {
    return {
      expanded: [],
      lsExpandFormSaveds: [],

      dgKullaniciKimlerDegerlendirecek: false,
      selectedFilter: null,
      selectedKullanicis: [],
      selectedPersonel: null,
      selectedPersonelItem: null,
      tab: null,
      dgBirim: false,
      selectedBirimIds: [],
      selectedBirimTurId: 0,
      required: value => !!value || 'Gerekli.',
      editedItem: {
        formId: null,
        name: "",
        // baslamaTarihi: (new Date()).toISOString().substr(0, 10),
        // bitisTarihi: new Date().toISOString().substr(0, 10),
        baslamaTarihi: "",
        bitisTarihi: "",
        loginGiris: false,
        onaylama: false,
        filtrelemeJson: "",
        durumId: 0
      },
      editedIndex: 0,
      durums: [],
      dialog: false,
      form: null,
      items: [],
      filterUser: {
        custom: "",
        ogrenciProgramIds: [],
        pbsAkademisyenBirimIds: [],
        pbsIdariBirimIds: [],
        pbsDigerBirimIds: [],
      },
      degerlendirmeUser: {
        custom: "",
        ogrenciProgramIds: [],
        pbsAkademisyenBirimIds: [],
        pbsIdariBirimIds: [],
        pbsDigerBirimIds: [],
      },
      headers: [
      
        {
          text: 'Form Adı',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Başlama Tarihi', value: 'baslamaTarihi', sortable: false },
        { text: 'Bitiş Tarihi', value: 'bitisTarihi', sortable: false },
        { text: 'Ekleme Tarihi', value: 'eklemeTarihi', sortable: false },
        { text: 'Durum', value: 'durum.name', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },

      ],
      values: [],
      personels: []
    }
  },
  created() {

    this.dataBind();
  },
  watch: {
    expanded(newExpanded) {


      if (newExpanded.length > 0) {
        FormSavedService.listKullaniciFormSaved(newExpanded[0].formId).then((result) => {
          this.lsExpandFormSaveds = result.data;
        }).catch((err) => {

        });
      }



    }
  }
  ,
  methods: {
    btnFormSavedDuzenle(guid) {
      router.push({ name: 'formgosterimedit', params: { id: guid } })
      console.log("dfsdf", guid);
    },

    // btnKimlerDegerlendirecekAdd() {
    //   this.selectedPersonelItem.filter = { ...this.selectedFilter };
    //   this.dgKullaniciKimlerDegerlendirecek = false;
    // },
    // btnKimlerDegerlendirecekDgShow(itemPersonel) {
    //   // this.selectedPersonelItem = itemPersonel;
    //   // this.selectedFilter ={ ...itemPersonel.filter} 
    //   // this.dgKullaniciKimlerDegerlendirecek = true;
    //   this.selectedPersonelItem = { ...itemPersonel };
    //   //this.selectedFilter ={ ...itemPersonel.filter} 
    //   this.dgKullaniciKimlerDegerlendirecek = true;


    // },
    // btnSelectedPersonelAdd() {
    //   this.selectedKullanicis.push({ ...this.selectedPersonel, filter: { ...this.degerlendirmeUser } })
    // },
    // cbPersonelChange(e) {
    //   console.log("cbPersonelChange", e);
    // },
    // btnBirimAdd() {
    //   if (this.selectedBirimTurId == 1) {
    //     this.filterUser.pbsAkademisyenBirimIds = this.selectedBirimIds;
    //   }
    //   if (this.selectedBirimTurId == 2) {
    //     this.filterUser.pbsIdariBirimIds = this.selectedBirimIds;
    //   }
    //   if (this.selectedBirimTurId == 3) {
    //     this.filterUser.pbsDigerBirimIds = this.selectedBirimIds;
    //   }

    //   this.dgBirim = false;
    // },
    // birimChange(birimtur) {
    //   this.selectedBirimTurId = birimtur;

    //   FilterUserService.PbsBirimAgaci(birimtur).then((result) => {
    //     console.log("PbsBirimAgaci", result.data);
    //     this.items = result.data;
    //     this.dgBirim = true;
    //     if (this.selectedBirimTurId == 1) {
    //       this.selectedBirimIds = this.filterUser.pbsAkademisyenBirimIds;
    //     }
    //     if (this.selectedBirimTurId == 2) {
    //       this.selectedBirimIds = this.filterUser.pbsIdariBirimIds;
    //     }
    //     if (this.selectedBirimTurId == 3) {
    //       this.selectedBirimIds = this.filterUser.pbsDigerBirimIds;
    //     }


    //   }).catch((err) => {

    //   });
    // },
    btnFormSave() {
      console.log("btnFormSave", this.$refs.frmForm.validate())

      if (!this.$refs.frmForm.validate()) {
        return false
      }

      this.editedItem.filtrelemeJson = JSON.stringify(this.filterUser);
      this.editedItem.degerlendirmeJson = JSON.stringify(this.selectedKullanicis);
      console.log("filtrelemeJson:", this.editedItem.filtrelemeJson);

      console.log("Save:", this.editedItem);
      if (this.editedItem.formId == null) {
        FormService.save(this.editedItem).then((result) => {
          this.values.push(result.data);
          this.dialog = false;
          this.$toast.success("Başarılı bir şekilde kaydedilmiştir.");

        }).catch((err) => {
          console.log("Error", err.response.data);
        });
      }
      else {
        FormService.update(this.editedItem.formId, this.editedItem).then((result) => {
          Vue.set(this.values, this.editedIndex, result.data)
          //Object.assign(this.values[this.editedIndex], this.editedItem)
          this.dialog = false;
          this.$toast.success("Başarılı bir şekilde güncellenmiştir.");

        }).catch((err) => {
          console.log("Error", err.response.data);
        });
      }


    },
    // editShowItem(item) {
    //   this.editedItem = Object.assign({}, item);
    //   if (this.editedItem?.filtrelemeJson) {
    //     { this.filterUser = JSON.parse(this.editedItem.filtrelemeJson); }
    //     if (this.editedItem?.degerlendirmeJson) {
    //       this.selectedKullanicis = JSON.parse(this.editedItem.degerlendirmeJson);

    //     }


    //     console.log("filterUser", this.filterUser);
    //   }


    //   this.editedIndex = this.values.indexOf(item);
    //   this.dialog = true;
    // },
    // btnFormUpdate(item) {

    // },

    // addShowItem(item) {
    //   this.editedItem.formId = null;
    //   this.filterUser = {
    //     custom: "",
    //     ogrenciProgramIds: [],
    //     pbsAkademisyenBirimIds: [],
    //     pbsIdariBirimIds: [],
    //     pbsDigerBirimIds: [],
    //   };
    //   this.dialog = true;
    //   this.editedIndex = -1;
    // },

    dataBind() {
      FormService.KullaniciDoldurulacakFormlar().then((result) => {
        this.values = result.data;
        console.log("listForm", result.data);
      }).catch((err) => {

      });
      DurumService.listDurums().then((result) => {
        this.durums = result.data;
      }).catch((err) => {

      });
      // FilterUserService.PbsPersonels().then((result) => {
      //   console.log("Personel:", result.data);
      //   this.personels = result.data;
      // }).catch((err) => {

      // });

    },
    editItem(v) {
      router.push({ name: 'formgosterim', params: { id: v.formId } })
    },
    // formTasarimGonder(v) {
    //   console.log("formTasarimGonder");
    //   router.push({ name: 'formtasarimi', params: { id: v.formId } })
    // }
    // ,
    // formBasvurulariGoster(v) {
    //   // console.log("formTasarimGonder");
    //   router.push({ name: 'formdata', params: { id: v.formId } })
    // }
  }
}
</script>